import { render, staticRenderFns } from "./FormSetting.vue?vue&type=template&id=d2d4f10c"
import script from "./FormSetting.vue?vue&type=script&lang=js"
export * from "./FormSetting.vue?vue&type=script&lang=js"
import style0 from "./FormSetting.vue?vue&type=style&index=0&id=d2d4f10c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports